__turbopack_context__.v({
  "className": "-2ekMa_className",
  "variable": "-2ekMa_variable",
});
